declare global {
  interface Window {
    __ENV__?: Record<string, string>;
  }
}

/**
 * Get an environment variable value at runtime.
 * Prioritizes window.__ENV__ (injected at container startup by Nginx),
 * falling back to import.meta.env[key] (Vite build-time/dev environment).
 */
export function getEnv(key: string, fallback = ''): string {
  if (typeof window !== 'undefined' && window.__ENV__ && window.__ENV__[key]) {
    return window.__ENV__[key];
  }
  const metaEnvValue = import.meta.env[key] as string | undefined;
  return metaEnvValue !== undefined && metaEnvValue !== '' ? metaEnvValue : fallback;
}
